import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Moon, ShieldAlert } from 'lucide-react';
export function ProblemSection() {
  return <section className="py-20 bg-white" data-id="element-141">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-142">
        {/* The Hook */}
        <FadeIn data-id="element-143">
          <div className="text-center mb-20" data-id="element-144">
            <Moon className="w-10 h-10 text-gold mx-auto mb-6" strokeWidth={1.5} data-id="element-145" />
            <p className="text-2xl md:text-3xl font-serif text-brown leading-relaxed italic" data-id="element-146">
              "Son las 11 de la noche. Todos en casa duermen, pero tú sigues
              despierta."
            </p>
            <div className="mt-8 space-y-6 text-lg text-brown/80 leading-relaxed" data-id="element-147">
              <p data-id="element-148">
                Tu mente es una lista interminable de pendientes, tu espalda
                está tensa y, aunque el mundo te llama "exitosa" y "fuerte", por
                dentro te sientes seca, sola y agotada.
              </p>
              <p data-id="element-149">
                Te acostumbraste a ser la que resuelve, la que protege y la que
                nunca falla. Pero ese escudo de hierro que te salvó en el
                pasado, hoy se ha convertido en la prisión que te impide
                disfrutar lo que has construido.
              </p>
            </div>
          </div>
        </FadeIn>

        {/* The Problem */}
        <FadeIn delay={0.2} data-id="element-150">
          <div className="bg-cream rounded-3xl p-8 md:p-12 relative overflow-hidden border border-gold/20" data-id="element-151">
            <div className="absolute top-0 right-0 w-32 h-32 bg-rose-light/20 rounded-bl-full" data-id="element-152" />

            <div className="relative z-10" data-id="element-153">
              <div className="flex items-center mb-6" data-id="element-154">
                <ShieldAlert className="w-8 h-8 text-rose mr-4" data-id="element-155" />
                <h2 className="text-3xl md:text-4xl font-serif text-brown" data-id="element-156">
                  La trampa de la <br className="hidden sm:block" data-id="element-157" />
                  <span className="text-rose" data-id="element-158">
                    Hiper-Independencia Traumática
                  </span>
                </h2>
              </div>

              <div className="space-y-6 text-lg text-brown/80" data-id="element-159">
                <p data-id="element-160">
                  Como la vida te obligó a salir adelante sola, aprendiste que{' '}
                  <strong data-id="element-161">"si no lo haces tú, nadie lo hará"</strong>.
                </p>
                <p data-id="element-162">
                  Este modo de supervivencia ha endurecido tu mirada, ha
                  bloqueado tu capacidad de recibir y ha matado la chispa en tus
                  relaciones.
                </p>
                <p className="font-medium text-brown" data-id="element-163">
                  Estás operando desde una energía masculina que te desgasta, te
                  oxida y te mantiene en un estado de alerta constante que tu
                  cuerpo ya no puede sostener.
                </p>
              </div>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}